// 统一状态入口

import { createContext, useContext } from 'react';
import AuthStore from './auth';
import HistoryStore from './history';
import ImageStore from './image';
import UserStore from './user';


const context = createContext({
    AuthStore,
    UserStore,
    ImageStore,
    HistoryStore
});
// 便于我们在控制台调试
window.stores = {
    AuthStore,
    UserStore,
    ImageStore,
    HistoryStore
}

export const useStore = () => useContext(context);
